import React from 'react'
import { GridHeaderCellProps } from '@progress/kendo-react-grid'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useAppSelector } from 'store'
import styled from 'styled-components'
import { isSortAscLogic, isSortDescLogic, SortLogic } from 'utils/QueryHelpers'

const HeaderLink = styled.a`
  display: flex;
  justify-content: center;
`

const HeaderTitleCell = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
  width: 100%;
`

const HeaderArrowCell = styled.div`
  display: flex;
  flex-direction: column;
`

export const HeaderSortCell: React.FC<GridHeaderCellProps> = (props) => {
  const gridState = useAppSelector((state) => state.grid)

  const gridSortBySortFieldSelector = (filterName: string) =>
    gridState.sort.find((x) => x.field === filterName)

  const sortState = gridSortBySortFieldSelector(props.field!)
  const sortStateDir = sortState?.dir || SortLogic.NONE

  const handleSortClick = (event: React.MouseEvent<HTMLElement>) => {
    props.onClick?.(event)
  }

  const isAsc = isSortAscLogic(sortStateDir)
  const isDesc = isSortDescLogic(sortStateDir)

  return (
    <HeaderLink onClick={handleSortClick}>
      <HeaderTitleCell>{props.title}</HeaderTitleCell>
      <HeaderArrowCell>
        <ChevronUp className='size-3' color={isAsc ? '#ff6358' : undefined} />
        <ChevronDown className='size-3' color={isDesc ? '#ff6358' : undefined} />
      </HeaderArrowCell>
    </HeaderLink>
  )
}
